import { render, staticRenderFns } from "./ResetPasswordComponentOld.vue?vue&type=template&id=40dd55f2&scoped=true"
import script from "./ResetPasswordComponentOld.vue?vue&type=script&lang=js"
export * from "./ResetPasswordComponentOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dd55f2",
  null
  
)

export default component.exports